export const DecedentIdContent = {
  decedentIdTitle: 'Social Security number',
  errorMsg: 'Your entry is invalid.',
};
